// extracted by mini-css-extract-plugin
export default {"formWrapper":"neurons_formWrapper__xEwSk","searchWrapper":"neurons_searchWrapper__94rUE"};